<template>
    <div class="search">
        <post-back :title="tr.searching_results" />
        <div class="container">
            <div class='no-found' v-if="found.length === 0">
                {{tr.not_found}}
            </div>
            <posts-grid :posts="found" :total="found.length" />
        </div>
    </div>
</template>
<script>
import PostsGrid from "./posts-grid.vue";
export default {
    components: { PostsGrid },
    name: 'search',
    computed: {
        seo() { return { title: this.trRaw.searching_results } },
        found() { return this.$store.getters.found; }
    }
}
</script>
<style lang="css" scoped>
.no-found {
    padding: 120px 0;
    font-size: 42px;
    text-align: center;
}
</style>